import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import M from 'materialize-css';
import { badgesType } from '../../constants/constants';
import ModalCompanyDialog from './ModalCompanyDialog';
import { Link, Redirect } from 'react-router-dom';
import './SafetyZones.css';
import convertXLSXtoSafetyData from '../../utils/XLSXUtil';

const refModal = React.createRef();

function SafetyZonesPeaceHill(props) {
  const [uidCompany, setUidCompany] = useState('');
  const [company, setCompany] = useState(null);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [schools, setSchools] = useState([]);
  const [type, setType] = useState('');
  const [country, setCountry] = useState('');
  const [failedPlaces, setFailedPlaces] = useState([]);
  const [validTypeBadge, setValidTypeBadge] = useState(false);
  const [validSchools, setValidSchools] = useState(false);
  const [validCountry, setValidCountry] = useState(false);
  const [validCompany, setValidCompany] = useState(false);
  const [showProcessText, setShowProcessText] = useState(false);
  const { firestore, companies, auth } = props;

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const safetyDataXls = convertXLSXtoSafetyData(bstr);
      setSchools(safetyDataXls);
    };
    reader.readAsBinaryString(file);
  };

  useEffect(() => M.AutoInit(), []);
  
  //TODO: remove if Functions.searchPlaces is used again
  useEffect(() => setFailedPlaces([]), []);

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  useEffect(() => {
    let elems = document.querySelectorAll('select');
    M.FormSelect.init(elems, {});
  }, []);

  const filterCompanies = (country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  };

  const search = (searchTerm) => {
    filterCompanies(country, searchTerm);
  };

  const updateCountry = (country) => {
    setCountry(country);
    filterCompanies(country, '');
  };

  const validFields = () => {
    const validSchools = schools.length > 0;
    const validCountry = country != null && country.length > 0;
    const validTypeBadge = type != null && type.length > 0;
    const validCompany = company != null;
    setValidSchools(validSchools);
    setValidCountry(validCountry);
    setValidTypeBadge(validTypeBadge);
    setValidCompany(validCompany);

    return validSchools && validCountry && validTypeBadge && validCompany;
  };

  const addSchools = async () => {
    if (validFields() && !showProcessText) {
      setShowProcessText(true);
      console.log('IS VALID');
      const searchPlaces = [];
      schools.forEach((school) => {
        const provinceSchool = school['School Province'];
        const codeSchool = school['School Code'];
        const citySchool = school['School City'];

        if (provinceSchool && codeSchool && citySchool) {
          const id = `${country}${provinceSchool}${codeSchool}`;
          const newPLaceSearch = {
            id: id,
            updatedAt: firestore.FieldValue.serverTimestamp(),
            companyName: company.companyName,
            uidCompany: uidCompany,
            schoolName: school['School Name'] ? school['School Name'] : '',
            website: school['Authority Website'] ? school['Authority Website'] : '',
            address: school['School Address1'] ? school['School Address1'] : '',
            phone: school['School Phone'] ? school['School Phone'] : '',
            email: school['School EMail'] ? school['School EMail'] : '',
            postalCode: school['School Postal Code'],
            schoolCode: codeSchool,
            state: provinceSchool,
            city: citySchool,
            country: country,
            type: type,
          };
          searchPlaces.push(newPLaceSearch);
        }
      });

      //TODO: This function is very expensive depending on the size of the csv
      // try {
      //   const pyns = await Functions.searchPlaces(searchPlaces);
      //   const fp = pyns.data.failedSearches;
      //   setFailedPlaces(fp);
      // } catch (e) {
      //   console.log('SEARCH PYNS PLACES', e.message);
      // }
      setShowProcessText(false);
      setSchools([]);
    } else {
      console.log('NO VALID');
    }
  };

  const renderTypeSelect = () => {
    const types = [];
    for (const key in badgesType) types.push(badgesType[key]);
    return (
      <div className="row">
        <div className="input-field col s12">
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Select a type</option>
            {types.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <label>Type</label>
        </div>
      </div>
    );
  };

  const renderSelectCountry = () => {
    return (
      <div className="row">
        <div className="input-field col s12">
          <select
            className="icons"
            value={country}
            onChange={(e) => {
              updateCountry(e.target.value);
            }}>
            <option value="" disabled>
              Select your Country
            </option>
            <option data-icon="images/ca.svg" value="CA">
              Canada
            </option>
            <option data-icon="images/us.svg" value="US">
              United States
            </option>
            <option data-icon="images/bo.svg" value="BO">
              Bolivia
            </option>
          </select>
          <label>Country</label>
        </div>
      </div>
    );
  };

  const renderSchools = () => {
    return (
      <div>
        <p>Schools</p>
        <div className="schoolsContainer">
          {schools && schools.length > 0 ? (
            schools.map((school) => {
              return (
                <div className="card" key={school['School Code']}>
                  <div className="card-content">
                    <p>School Code: {school['School Code']}</p>
                    <p>Name: {school['School Name']}</p>
                    <p>City: {school['School City']}</p>
                    <p>Province: {school['School Province']}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  const renderFailedPlaces = () => {
    return (
      <div>
        <p>Failed Places</p>
        <div className="schoolsContainer">
          {failedPlaces && failedPlaces.length > 0 ? (
            failedPlaces.map((fp) => {
              return (
                <div className="card" key={fp.place.id}>
                  <div className="card-content">
                    <p>School Code: {fp.place.schoolCode}</p>
                    <p>Name: {fp.place.schoolName}</p>
                    <p>City: {fp.place.city}</p>
                    <p>Province: {fp.place.state}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  if (!auth.uid) {
    return <Redirect to="/signin" />;
  }

  return (
    <div className="container">
      <label htmlFor="file">Enter the excel file for add Safety Zones</label>
      <br />
      <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload} />
      <br />
      {showProcessText ? <p>Processing...</p> : <div />}
      <div className="row">
        <div className="col s6 card-content">
          {renderTypeSelect()}
          {renderSelectCountry()}
          <div className="row">
            <div className="input-field">
              <div className="col s6">
                <label htmlFor="company_uid">Company UID</label>
                {company ? <p>{company.companyName}</p> : <div />}
                <input id="company_uid" type="text" name="uidCompany" value={uidCompany} onChange={(e) => setUidCompany(e.target.value)} />
              </div>
              <div className="col s6">
                <Link to="#" onClick={() => openCompanyDialog()}>
                  Select company
                </Link>
              </div>
            </div>
          </div>
          <div>
            {!validTypeBadge ? <p className="red-text"> Select Type</p> : <div />}
            {!validCountry ? <p className="red-text">Select Country</p> : <div />}
            {!validCompany ? <p className="red-text">Select Company</p> : <div />}
            {!validSchools ? <p className="red-text">Enter CSV</p> : <div />}
            <button className="waves-effect waves-light btn btn-large" onClick={addSchools}>
              Add Schools
            </button>
          </div>
        </div>
        <div className="col s6 row">
          <div className="col s6">{renderSchools()}</div>
          <div className="col s6">{renderFailedPlaces()}</div>
        </div>
      </div>
      <ModalCompanyDialog refModal={refModal} search={search} currentCompanies={currentCompanies} setUidCompany={setUidCompany} setCompany={setCompany} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]), connect(mapStateToProps))(SafetyZonesPeaceHill);
